function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".system10_svg__st0{fill:#ffa9d3}.system10_svg__st1{fill:#00b06a}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "system10_svg__Layer_5"
}, /*#__PURE__*/React.createElement("path", {
  className: "system10_svg__st0",
  d: "M500 500H0C0 223.9 223.9 0 500 0v500z"
}), /*#__PURE__*/React.createElement("path", {
  className: "system10_svg__st1",
  d: "M500 0C223.9 0 0 223.9 0 500V0h500z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "system10_svg__Layer_7"
}, /*#__PURE__*/React.createElement("path", {
  className: "system10_svg__st1",
  d: "M500 500H0C0 223.9 223.9 0 500 0v500z"
}), /*#__PURE__*/React.createElement("path", {
  className: "system10_svg__st0",
  d: "M500 0C223.9 0 0 223.9 0 500V0h500z",
  id: "system10_svg__Layer_6"
}));

function SvgSystem10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIyLjEuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiCgkgdmlld0JveD0iMCAwIDUwMCA1MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUwMCA1MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojRkZBOUQzO30KCS5zdDF7ZmlsbDojMDBCMDZBO30KPC9zdHlsZT4KPGcgaWQ9IkxheWVyXzUiPgoJPHBhdGggY2xhc3M9InN0MCIgZD0iTTUwMCw1MDBIMEMwLDIyMy45LDIyMy45LDAsNTAwLDBWNTAweiIvPgoJPHBhdGggY2xhc3M9InN0MSIgZD0iTTUwMCwwQzIyMy45LDAsMCwyMjMuOSwwLDUwMFYwSDUwMHoiLz4KPC9nPgo8ZyBpZD0iTGF5ZXJfNyI+Cgk8cGF0aCBjbGFzcz0ic3QxIiBkPSJNNTAwLDUwMEgwQzAsMjIzLjksMjIzLjksMCw1MDAsMFY1MDB6Ii8+Cgk8ZyBpZD0iTGF5ZXJfNiI+CgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTUwMCwwQzIyMy45LDAsMCwyMjMuOSwwLDUwMFYwSDUwMHoiLz4KCTwvZz4KPC9nPgo8L3N2Zz4K";
export { SvgSystem10 as ReactComponent };